/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const EligibleResult = {
    ELIGIBLE: 'ELIGIBLE',
    NONELIGIBLE: 'NONELIGIBLE',
    LIMITED: 'LIMITED'
} as const;
export type EligibleResult = typeof EligibleResult[keyof typeof EligibleResult];

